module.exports = __webpack_public_path__ + "img/logo-facebook.7c8cbd83.svg";